import React from 'react'
import { Link } from 'react-router-dom'
import bgBennies from '../../assets/images/background/bg-bennies.png'
// import bg2 from '../../assets/images/background/bg-2.png'
import offerimg1 from '../../assets/images/resource/offer-image-1.jpg'
import offerimg2 from '../../assets/images/resource/offer-image-2.jpg'
import offerImgDrinks from '../../assets/images/resource/offer-image-drinks.jpg'

function Offer() {

  const offers = [
    {
      image: offerimg1,
      title: 'Breakfast',
      link: 'https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu'
    },
    {
      image: offerimg2,
      title: 'Lunch',
      link: 'https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu'
    },
    {
      image: offerImgDrinks,
      title: 'Drinks',
      link: 'https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu'
    }
  ];

  return (
    <>
      <section className="we-offer-section">
        <div className="left-bot-bg"><img src={bgBennies} alt="" title="" /></div>
        <div className="right-top-bg"><img src={bgBennies} alt="" title="" /></div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>Elevated flavours</span></div>
            <div className="pattern-image">
              <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
            </div>
            <h2>Driven by flavour and freshness</h2>
            <div className="text">Enjoy this Amazing Experience with our Signature Items. Come try it for yourself!</div>
          </div>
          <div className="row justify-content-center clearfix">
            {offers.map((offer, index) => (
              <div key={index} className="offer-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 300}ms`}>
                  <div className="image"><Link to={`${offer.link}`}><img src={offer.image} alt="" /></Link></div>
                  <h3><Link to={`${offer.link}`}>{offer.title}</Link></h3>
                  <div className="more-link"><Link to={`${offer.link}`}>view all menu</Link></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Offer
